import { layoutApi, type WidgetDef } from './api';
import { loadLayout } from './layout';
import { clearWidgetCache } from './components/Widgets';

/**
 * "Op mijn startscherm": een rij toevoegen aan het eigen startscherm van dit profiel.
 * Heeft het profiel nog geen eigen indeling, dan beginnen we met een kopie van die van iedereen.
 */
export async function pinToHome(title: string, source: WidgetDef['source'], view: WidgetDef['view'] = 'poster'): Promise<void> {
  const own = await layoutApi.get('profile');
  const layout = own.layout ?? (await layoutApi.get('default')).layout;
  if (!layout || !layout.hubs.length) throw new Error('Geen indeling gevonden');
  const home = layout.hubs[0];
  const id = Math.random().toString(36).slice(2, 10);
  // Bovenaan, maar onder een eventuele spotlight
  const at = home.widgets[0]?.view === 'spotlight' ? 1 : 0;
  home.widgets.splice(at, 0, { id, title, source, view, show: 'all', limit: 20, enabled: true });
  await layoutApi.save('profile', layout);
  clearWidgetCache();
  await loadLayout(true);
}
